export default {
    SET_TAGGING_ITEM(state, taggingItem) {
        state.taggingItem = taggingItem;
    },
    SET_TAGGING_MODE(state, isTagging) {
        state.isTaggingActive = isTagging;
    },
    SET_CASE_ID(state, caseId) {
        state.caseId = caseId;
    },
    SET_CLIENT_ID(state, clientId) {
        state.clientId = clientId;
    },
    SET_DEVICE_INFO(state, device) {
        state.device = device;
    },
    SET_CLIENT_INFO(state, clientInfo) {
        state.clientInfo = clientInfo;
    },
    SET_LOADING_STATE(state, isLoading) {
        state.isLoading = isLoading;
    },
    RESET_STATE(state) {
        state.isTagging = false;
        state.taggingItem = {};
    }
};